module.exports = __webpack_public_path__ + "src/img/stylemarks/laptop-3.f8e66.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/stylemarks/laptop-3.jpg
// module id = 118
// module chunks = 0